import { fork, takeLatest, all } from "redux-saga/effects";
import { LOGIN_BEGIN, AUTO_LOGIN } from "../actions/LoginActions";
import { loginSaga, autoLoginSaga } from "./LoginSaga";
import { LOGOUT_BEGIN } from "../actions/LogoutActions";
import { logoutSaga } from "./LogoutSaga";
import { START_NEXT_REVIEW } from "../actions/NextReviewActions";
import { nextReviewSaga } from "./NextReviewSaga";
import { START_REVIEW_DECISION } from "../actions/ReviewDecisionActions";
import { reviewDecisionSaga } from "./ReviewDecisionSaga";

export default function* rootSaga() {
    yield all([
        fork(watchLoginSaga),
        fork(watchAutoLoginSaga),
        fork(watchLogoutSaga),
        fork(watchNextReviewSaga),
        fork(watchReviewDecisionSaga)
    ]);
}

function* watchLoginSaga() {
    yield takeLatest(LOGIN_BEGIN, loginSaga);
}
  
function* watchAutoLoginSaga() {
    yield takeLatest(AUTO_LOGIN, autoLoginSaga);
}

function* watchLogoutSaga() {
    yield takeLatest(LOGOUT_BEGIN, logoutSaga);
}

function* watchNextReviewSaga() {
    yield takeLatest(START_NEXT_REVIEW, nextReviewSaga);
}

function* watchReviewDecisionSaga() {
    yield takeLatest(START_REVIEW_DECISION, reviewDecisionSaga);
}